export function isStairwell(value) {
    return /^.{0,255}$/.test(value || '');
}
